// @ts-ignore
import { scroller, animateScroll, Element, Events } from "react-scroll"
import deepMerge from "deepmerge"

const DEFAULT_OPTIONS = {
  duration: 200,
  delay: 50,
  smooth: true,
}

interface Options {
  containerId?: string
  delay?: number
  duration?: number
  isDynamic?: boolean
  offset?: number
  smooth?: boolean
}

export function scrollTo(name: string, options: Options = DEFAULT_OPTIONS) {
  scroller.scrollTo(name, deepMerge.all([{}, DEFAULT_OPTIONS, options]))
}

export function scrollToTop(options: Options = DEFAULT_OPTIONS) {
  animateScroll.scrollToTop(deepMerge.all([{}, DEFAULT_OPTIONS, options]))
}

export const waypoint = (cb: () => void, ref: HTMLDivElement) => {
  const observerFooter = new IntersectionObserver(
    (entries) => {
      if (entries[0] && entries[0].isIntersecting) {
        cb()
      }
    },
    { threshold: 0 },
  )
  observerFooter.observe(ref)
}

export { Element, Events }
